import { Reveal, ChapterTag, GoldButton } from "@/components/Reveal";
import { scrollToId } from "@/constants/site";

export const Budget = () => (
  <section id="budget" data-testid="budget-section" className="bg-bone px-5 py-20 text-obsidian sm:px-8 sm:py-28 lg:px-16 lg:py-36">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <ChapterTag index="01" label="Our Philosophy" light />
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-20">
        <Reveal className="lg:col-span-7">
          <h2 className="font-serif text-4xl font-light leading-tight tracking-tight sm:text-5xl lg:text-6xl">
            Your Budget. <span className="italic text-gold-muted">Your Journey.</span>
          </h2>
          <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-zinc-600 sm:text-lg">
            Every traveler is different, and every journey should be different too.
          </p>
          <p className="mt-4 max-w-xl text-base font-light leading-relaxed text-zinc-600 sm:text-lg">
            Whether you're planning a ₹25,000 getaway or a ₹2,50,000 escape, we design the journey
            around your preferences, priorities, schedule and budget.
          </p>
          <div className="mt-10">
            <GoldButton testId="budget-plan-cta" onClick={() => scrollToId("plan")}>
              Plan My Journey
            </GoldButton>
          </div>
        </Reveal>
        <Reveal delay={0.15} className="flex items-center lg:col-span-5">
          <div className="w-full border-l-2 border-gold-muted/60 pl-8">
            {["You tell us what you want.", "You tell us your budget.", "We coordinate the details."].map((line, i) => (
              <p
                key={line}
                data-testid={`budget-promise-${i}`}
                className={`font-serif text-2xl font-light leading-snug sm:text-3xl ${i === 2 ? "italic text-gold-muted" : "text-zinc-800"} ${i > 0 ? "mt-5" : ""}`}
              >
                {line}
              </p>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
